{
    "list_page__title": "Campaigns",
    "list_page__empty_state_title": "No campaigns yet",
    "list_page__empty_state_description": "Promote articles to selected customers – your reps get tasks for them."
}
